import { DoubleArrow } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { showResourcecategory, toggleFormResourcecategories } from '../../../../../redux/actions/resourcecategories'
import { IRootState } from '../../../../../redux/types'
import TypeFilter from '../../../../shared/components/TypeFilter'
import HiddenDesktop from '../../../../shared/styles/HiddenDesktop'
import ScrollSubheader from '../../../../shared/styles/ScrollSubHeader'
import HasKnowToBuy from '../../../../shared/utils/HasKnowToBuy'

interface ResourceTypeFilterProps {
  filters: any
  handleChangeFilter: any
  setResourcetypeId: any
}

function ResourceTypeFilter({ filters, handleChangeFilter, setResourcetypeId }: ResourceTypeFilterProps) {
  const { t } = useTranslation(['global'])
  const dispatch = useDispatch()

  const { user: authUser } = useSelector((state: IRootState) => state.auth)
  const { resourcetypes } = useSelector((state: IRootState) => state.resourcetype)
  const { resourcecategories } = useSelector((state: IRootState) => state.resourcecategory)

  const handleAction = (action: string, id: number) => {
    if (action === 'add') {
      setResourcetypeId(id)
      dispatch(toggleFormResourcecategories())
    } else if (action === 'edit') dispatch(showResourcecategory(id))
  }

  const SubHeaderElement: HTMLElement | null = document.getElementById('windowLibraryAdmin')
  let midOfWidth = window.innerWidth / 2
  return (
    <ScrollSubheader id="windowLibraryAdmin">
      <TypeFilter
        id={null}
        type={t('all')}
        categories={[]}
        active={filters.resourcetype_id === null}
        filterCategoryId={filters.category_id}
        handleChangeFilter={handleChangeFilter}
      />
      {resourcetypes.map((resourcetype: any) => {
        if (resourcetype.id === 4) {
          return (
            <HasKnowToBuy key={resourcetype.id}>
              <TypeFilter
                id={resourcetype.id}
                type={resourcetype.name}
                categories={[]}
                active={resourcetype.id === filters.resourcetype_id}
                handleChangeFilter={handleChangeFilter}
              />
            </HasKnowToBuy>
          )
        }

        return (
          <TypeFilter
            key={resourcetype.id}
            id={resourcetype.id}
            type={resourcetype.name}
            categories={resourcecategories.filter((category: any) => category.resourcetype_id === resourcetype.id)}
            active={resourcetype.id === filters.resourcetype_id}
            admin={authUser.role_id === 1}
            filterCategoryId={filters.category_id}
            handleChangeFilter={handleChangeFilter}
            handleAction={handleAction}
          />
        )
      })}
      <HiddenDesktop>
        <IconButton
          className="buttonScroll"
          onClick={() => {
            SubHeaderElement?.scrollBy(midOfWidth, 0)
          }}
        >
          <DoubleArrow />
        </IconButton>
      </HiddenDesktop>
    </ScrollSubheader>
  )
}

export default ResourceTypeFilter
